"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_CATALOG_DATA_FOR_DASHBOARD = void 0;
const gql_1 = require("../../../__generated__/gql");
exports.GET_CATALOG_DATA_FOR_DASHBOARD = (0, gql_1.gql)(`
  query CatalogDataForDashboard(
    $ids: [ID!]
    $productTreeId: ID!
    $productTreeNodeId: ID!
  ) {
    catalogs(ids: $ids) {
      edges {
        node {
          id
          closedTickets: linkedFrom(filter: { status: { in: CLOSED }, title: {equals: "Enrich Ticket"} }) {
            totalCount
            edges {
              node {
                ticket {
                  closedAt
                }
              }
            }
          }
          statistics(productTreeId: $productTreeId, productTreeNodeIds: [$productTreeNodeId]) {
            attributes {
              totals {
                applied
                notApplicable
                total
                unknown
                uniqueAttributes
                uniqueValues
                inferenceAttributes
                derivationAttributes
                inferenceValues
                derivationValues
              }
            }
          }
          products {
            totalCount
          }
        }
      }
    }
  }
`);
